<template>
  <vue-final-modal
      v-model="showModal"
      @click-outside="modalClose"
      classes="modal-container"
      content-class="modal-content">
    <span class="modal__result-header">
      <span class="close-btn" @click="modalClose">
        <span>x</span>
      </span>
    </span>
    <span class="modal__result-details">
      <span class="result-icon">
         {{ resultIcon }}
      </span>
      <span class="result-title">{{ resultTitle }} </span>
      <span class="result-subtitle">{{ resultSubtitle }} </span>
      <span class="result-score">{{ convertNumberToLangWise(resultPlayed.total_correct)}}/{{ resultPlayed.total_quiz }}</span>
      <span class="level-complete">{{ $t('YOU_HAVE_COMPLETED') }} <span>{{ convertNumberToLangWise(Math.ceil(resultPlayed.progress_topic * 100)) }}%</span></span>
      <ProgressBar :complete="(Math.ceil(resultPlayed.progress_topic * 100))" />
      <span class="next-level">{{ $t('LEVEL') }} {{ convertNumberToLangWise(resultPlayed.level) }}</span>
      <span class="another-play-text">{{ $t('EXPLORE') }} </span>

    </span>
    <div class="d-flex justify-content-around align-items-center">
      <argon-button
                    color="dark"
                    variant="gradient"
                    class="my-4"
                    @click="nextTopic"
                    style="background: none; color: #7BDA5A;">
        {{ $t('NEXT_TOPIC') }}
      </argon-button>
      <argon-button color="dark"
                    variant="gradient"
                    class="my-4"
                    style="background: none; color: #8424A5"
                    @click="playAgain">
        {{ $t('TRY_AGAIN') }}
      </argon-button>
    </div>

    <div class="d-flex justify-content-center align-items-center">
      <argon-button
          color="dark"
          variant="gradient"
          class="my-4"
          @click="challengeOpen"
          style="background: #8424A5;">{{ $t('CHALLENGE_NOW') }}
      </argon-button>
    </div>
  </vue-final-modal>
</template>

<script>
import {VueFinalModal} from 'vue-final-modal';
import {convertEnglishToMayanmar} from "@/helper/numberHelper";
import ArgonButton from "@/components/ArgonButton.vue";
import ProgressBar from "@/views/components/ProgressBar";

export default {
  name: "ResultModal",
  props: ['modalShow', 'resultPlayed'],
  components: {
    VueFinalModal,
    ArgonButton,
    ProgressBar
  },
  data() {
    return {
      showModal: this.modalShow,
      resultTitle: this.$t('CONGRATULATION'),
      resultSubtitle: this.$t('YOU_HAVE_PASSED'),
      resultIcon: '😀'
    }
  },
  created() {
    let scoreCalculate = Math.ceil((this.resultPlayed.total_correct / this.resultPlayed.total_quiz ) * 100);
    if (33 <= scoreCalculate && 66 > scoreCalculate ) {
      this.resultIcon = '🙂';
      this.resultTitle = this.$t('NOT_BAD');
      return;
    }
    if (33 > scoreCalculate) {
      this.resultIcon = '😥';
      this.resultTitle = this.$t('BETTER_LUCK_NEXT_TIME');
      this.resultSubtitle = this.$t('YOU_HAVE_FAILED');
    }
  },
  methods: {
    convertNumberToLangWise(data) {
      let numberDataWithLang = {
        'number': data,
        'lang': this.$store.getters.language
      };
      return convertEnglishToMayanmar(numberDataWithLang);
    },
    modalClose() {
      this.emitter.emit('result-modal-close-event', {'eventContent': false});
    },
    nextTopic() {
      this.emitter.emit('next-topic-run', {'eventContent': false});
    },
    playAgain() {
      this.emitter.emit('play-again', {'eventContent': false});
    },
    challengeOpen() {
      this.emitter.emit('challenge-friend-modal-open', {'eventContent': true});
    }
  }
}
</script>

<style scoped>
:deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

:deep .modal-content {
  display: flex;
  flex-direction: column;
  margin-right: 10%;
  margin-left: 10%;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
}
@media only screen and (min-width: 1200px) {
  :deep .modal-content {

    margin-left:19%;
    margin-right:19%;


  }
}

.dark-mode div:deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
</style>
